"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCellColor = void 0;
var ColorScale_1 = __importDefault(require("../colorScale/ColorScale"));
var Heatmap_Enums_1 = require("../Heatmap_Enums");
var getCellColor = function (cell, model) {
    var colorRange = ["#eee5ff", "#3d00c1"];
    var colorScale = new ColorScale_1.default(model.impactRange[0], model.impactRange[1], colorRange);
    if (isDarkGray(cell))
        return cellColorObject("#f2f2f2", "#000");
    if (!cell.value)
        return cellColorObject("#f8f8f8", "#000");
    var backgroundColor = colorScale.getColor(cellValue(cell));
    var color = backgroundColor.isDarkColor() ? "#fff" : "#000";
    return cellColorObject(backgroundColor.toHexString(), color);
};
exports.getCellColor = getCellColor;
var cellColorObject = function (bacgroundColor, color) {
    return {
        backgroundColor: bacgroundColor,
        color: color
    };
};
var isTotalsRow = function (cell) {
    return cell.yAxisKey === Heatmap_Enums_1.Rows.Totals;
};
var isDarkGray = function (cell) {
    return (isTotalsRow(cell)
        ||
            (!cell.value
                &&
                    isOddXOrYAxisCell(cell)));
};
var isOddXOrYAxisCell = function (cell) {
    return (isOddXAxisCell(cell) || isOddYAxisCell(cell));
};
var isOddXAxisCell = function (cell) {
    return +cell.xAxisKey % 2 === 0;
};
var isOddYAxisCell = function (cell) {
    return (+cell.yAxisKey % 2 !== 0 && cell.yAxisKey !== Heatmap_Enums_1.Rows.Parent);
};
var cellValue = function (cell) {
    if (!cell)
        return "0";
    return cell.value;
};
